var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpbPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10918_10507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3108 13.4742V21.2976H52.5172V15.8096H49.8273V21.2976H47.0337V13.4736H55.3108V13.4742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2966 21.5772C43.7974 21.5772 45.6545 20.0439 45.6545 17.7193C45.6545 15.4695 44.2843 14.0087 41.9945 14.0087C40.9377 14.0087 40.0657 14.3807 39.4089 15.0225C39.5657 13.6959 40.6875 12.7273 41.9227 12.7273C42.2078 12.7273 44.354 12.7228 44.354 12.7228L45.5675 10.4004C45.5675 10.4004 42.8732 10.4617 41.6206 10.4617C38.7588 10.5116 36.8257 13.1129 36.8257 16.2724C36.8257 19.9532 38.711 21.5772 41.2966 21.5772ZM41.3118 16.0657C42.2403 16.0657 42.8841 16.6759 42.8841 17.7191C42.8841 18.658 42.3121 19.4316 41.3118 19.4337C40.355 19.4337 39.7113 18.7169 39.7113 17.7351C39.7113 16.6916 40.355 16.0657 41.3118 16.0657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5517 18.6783C34.5517 18.6783 33.8919 19.0586 32.9066 19.1306C31.7738 19.1642 30.7645 18.4487 30.7645 17.1775C30.7645 15.9375 31.6551 15.2268 32.8781 15.2268C33.6279 15.2268 34.6199 15.7466 34.6199 15.7466C34.6199 15.7466 35.3458 14.4146 35.7218 13.7484C35.0333 13.2266 34.1162 12.9404 33.0495 12.9404C30.3575 12.9404 28.2725 14.6956 28.2725 17.1618C28.2725 19.6594 30.2322 21.3738 33.0495 21.322C33.837 21.2927 34.9234 21.0162 35.5855 20.5908L34.5517 18.6783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.200195 6.96582L4.0754 13.8925V18.1176L0.204729 25.0306L0.200195 6.96582Z",
    fill: "#5B57A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0796 11.3712L18.7108 9.14561L26.1423 9.13867L15.0796 15.9157V11.3712Z",
    fill: "#D90751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.059 6.92453L15.0796 16.0952L11.1953 13.7085V0L15.059 6.92453Z",
    fill: "#FAB718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1422 9.13893L18.7105 9.14587L15.059 6.92453L11.1953 0L26.1422 9.13893Z",
    fill: "#ED6F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0796 25.069V20.6197L11.1953 18.2783L11.1974 32.0005L15.0796 25.069Z",
    fill: "#63B22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7015 22.8637L4.07513 13.8925L0.200195 6.96582L26.1263 22.8546L18.7015 22.8637Z",
    fill: "#1487C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1978 32.0004L15.0794 25.0689L18.7015 22.8636L26.1263 22.8545L11.1978 32.0004Z",
    fill: "#017F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.20459 25.0305L11.2267 18.2785L7.52112 16.0049L4.07526 18.1174L0.20459 25.0305Z",
    fill: "#984995"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10918_10507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.2,
    height: 32,
    fill: "white",
    transform: "translate(0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpbPayment);
export default __webpack_public_path__ + "static/media/spb-payment.29bc330da81d15101ec59fc218fe5ecf.svg";
export { ForwardRef as ReactComponent };